export const Constant = {
    API_URL: 'http://66.96.83.185/',
    ROWS_PER_PAGE: 15,
    USERNAME: '',
    PASSWORD: '',
    get API_BASE_URL() {
        return `${this.API_URL}elo/`;
    }
};

//Production
//http://66.96.83.185/elo

//Development
//http://37.60.190.110/elo
